<template>
  <div class="rootDiv">
    <div class="title-div">
      <span>{{ airportModel.jCMC }}</span>
    </div>
    <Cell class="cell" title="城市">
      <span>{{ airportModel.sMC }}{{ airportModel.cS === airportModel.sMC ? '' : '==>' + airportModel.cS }}</span>
    </Cell>
    <Cell class="cell" title="地址">
      <span>{{ airportModel.dZ }}</span>
    </Cell>
    <Cell class="cell" title="等级" v-if="airportModel.dJ">
      <span>{{ airportModel.dJ }}</span>
    </Cell>
    <Cell class="cell" title="IATA" v-if="airportModel.iATA">
      <span>{{ airportModel.iATA }}</span>
    </Cell>
    <Cell class="cell" title="ICAO" v-if="airportModel.iCAO">
      <span>{{ airportModel.iCAO }}</span>
    </Cell>
    <Cell class="cell" title="地区" v-if="airportModel.dQ">
      <span>{{ airportModel.dQ }}</span>
    </Cell>
    <Cell class="cell" title="类型">
      <span>{{ airportModel.lX }}</span>
    </Cell>
    <Cell class="cell" title="最大跑道长度（米）" v-if="airportModel.zDPDCD!==0">
      <span>{{ airportModel.zDPDCD }}</span>
    </Cell>
    <Cell class="cell" title="经度" v-if="airportModel.jD">
      <span>{{ airportModel.jD }}</span>
    </Cell>
    <Cell class="cell" title="纬度" v-if="airportModel.wD">
      <span>{{ airportModel.wD }}</span>
    </Cell>
    <Cell class="cell" title="海拔（米）" v-if="airportModel.hB!==0">
      <span>{{ airportModel.hB }}</span>
    </Cell>
    <Cell class="cell" title="电话" v-if="airportModel.dH">
      <span>{{ airportModel.dH }}</span>
    </Cell>
    <Cell title="卫星地图"
          style="margin-bottom: 10px;text-align: left;min-height: 40px;color: blue" is-link
          v-on:click.native="goMap(airportModel.jCMC,airportModel.lng, airportModel.lat)"></Cell>
    <Cell title="百度百科"
          style="margin-bottom: 10px;text-align: left;min-height: 40px;color: blue" is-link
          v-on:click.native="goBaiDu(airportModel.jCMC )"></Cell>
    <div class="title-div">
      <span>机场详情</span>
    </div>
    <div v-html="airportModel.jCXQ" style="text-align:left"></div>
  </div>
</template>

<script>
import {Indicator, Cell} from "mint-ui";

export default {
  name: "AirportDetails",
  data() {
    return {
      id: null,
      airportModel: {},
      getAirportDetailsUrl: '/api/airport/getAirportDetails',
    }
  },
  components: {
    Cell
  },
  mounted() {
    if (this.$route.query.key_id !== undefined) {
      this.id = this.$route.query.key_id
      this.getAirportDetails()
    } else
      this.$router.go(-1)
  },
  methods: {
    goMap(mc, jd, wd) {
      if (jd === 0 || wd === 0) {
        this.$messagebox.alert('缺少经纬度坐标')
      } else {
        let list = []
        let item = {title: mc, data: {lng: jd, lat: wd}}
        list.push(item)
        this.$router.push({name: 'm_bing_map', query: {point: list}})
      }
    },
    goBaiDu(name) {
      window.location.href = "https://baike.baidu.com/item/" + name
    },
    getAirportDetails() {
      Indicator.open({
        text: '加载中...',
        spinnerType: 'fading-circle'
      });
      let that = this
      that.$ajax({
        method: 'get',
        url: that.getAirportDetailsUrl,
        params: {id: that.id},
        headers: {token: that.token, needToken: 'false'}
      }).then((response) => {
        Indicator.close()
        if (!response.data.result)
          that.$messagebox.alert(response.data.message)
        else {
          that.airportModel = response.data['responseData']
        }
      }).catch(response => {
        Indicator.close()
        this.$messagebox.alert(response.status === 404 ? "服务器连接失败" : "未知错误，请联系服务商", '服务器异常')
      })
    },
  }
}
</script>

<style lang="less" scoped>
.title-div {
  background-color: #8450C5;
  padding-top: 5px;
  padding-bottom: 5px;

  span {
    font-size: 1.4rem;
    color: white;
  }
}

.rootDiv {
  margin-top: -0.5rem;
}

.cell {
  text-align: left;
}

/deep/ .mint-cell-title {
  min-width: 50px;
}
</style>
